import { useEffect, useState } from "react";
import { useApp } from "@/context/AppContext";
import { useSeo } from "@/lib/seo";
import { api } from "@/lib/api";

export default function Legal({ type }) {
  const { t, tx, siteInfo } = useApp();
  useSeo(type === "imprint" ? "imprint" : "privacy");
  const [imp, setImp] = useState({});
  useEffect(() => {
    if (type === "imprint") api.get("/impressum").then(({ data }) => setImp(data || {})).catch(() => {});
  }, [type]);
  const title = type === "imprint" ? t.legal.imprint : t.legal.privacy;
  const F = t.legal.fields;
  const rows = [
    [F.owner, imp.owner],
    [F.email, imp.email],
    [F.phone, imp.phone],
    [F.register, imp.register],
    [F.tax, imp.tax],
    [F.iban, imp.iban],
    [F.court, tx(imp.court)],
  ].filter(([, v]) => v);

  return (
    <div className="pt-32 md:pt-40 pb-24">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-display font-black text-4xl md:text-6xl tracking-tighter">{title}</h1>
        {type === "imprint" ? (
          <div className="mt-10 space-y-6 text-slate-700 leading-relaxed" data-testid="imprint-content">
            <div>
              <p className="font-display font-bold text-xl">{imp.company || siteInfo.company}</p>
              {tx(imp.address) && <p className="whitespace-pre-line mt-2">{tx(imp.address)}</p>}
            </div>
            <dl className="space-y-3">
              {rows.map(([label, value]) => (
                <div key={label} className="grid sm:grid-cols-[220px_1fr] gap-1 sm:gap-4 border-b border-slate-100 pb-3">
                  <dt className="text-xs uppercase tracking-widest text-slate-400 pt-1">{label}</dt>
                  <dd>{value}</dd>
                </div>
              ))}
            </dl>
            {(siteInfo.contacts || []).length > 0 && (
              <div className="grid sm:grid-cols-[220px_1fr] gap-1 sm:gap-4">
                <div className="text-xs uppercase tracking-widest text-slate-400 pt-1">{F.phone}</div>
                <div>{(siteInfo.contacts || []).map((c) => (<p key={c.phone}>{c.name}: {c.phone}</p>))}</div>
              </div>
            )}
            {tx(imp.additional) && <p className="whitespace-pre-line text-slate-600">{tx(imp.additional)}</p>}
          </div>
        ) : (
          <div className="mt-10 space-y-4 text-slate-700 leading-relaxed">
            <div className="border-l-4 border-accent2 bg-slate-50 px-5 py-4 text-sm text-slate-600">{t.legal.placeholder}</div>
            <p><strong className="font-display">{siteInfo.company}</strong></p>
            <p className="whitespace-pre-line">{tx(siteInfo.address)}</p>
            <p>E-Mail: {siteInfo.email}</p>
            <h2 className="font-display font-bold text-2xl pt-4">1. Datenschutz auf einen Blick</h2>
            <p className="text-slate-500 text-sm">[Platzhalter – finalen DSGVO-Text über eRecht24 oder Anwalt einfügen.]</p>
            <h2 className="font-display font-bold text-2xl pt-4">2. Kontaktformular</h2>
            <p className="text-slate-500 text-sm">Die im Kontaktformular eingegebenen Daten werden ausschließlich zur Bearbeitung Ihrer Anfrage gespeichert. [Platzhalter]</p>
          </div>
        )}
      </div>
    </div>
  );
}
